import React, { createContext, useContext, useReducer } from "react";
import { ACTION_TYPES, PublicationsReducer, PublicationsState } from "./publications-reducer";
import { PaginationResponse } from "models/pagination-response";
import { IOfficialDiaryPagedResponse } from "models/response/official-diary-paged-response";
import { IOfficialDiaryPagedRequest } from "models/request/official-diary-paged-request";
import { IPublicationPagedResponse } from "models/response/publication-paged-response";
import { IPublicationPagedReqeust } from "models/request/publication-paged-request copy";

const PublicationsContext = createContext<PublicationsState | undefined>(undefined);
const PublicationsContextDispatchContext = createContext({} as any);

const PublicationsProvider = ({ children }: { children: React.ReactNode }) => {
    const [state, dispatch] = useReducer(PublicationsReducer, { publicationRequest: { startDate: "", endDate: "" } as IPublicationPagedReqeust,  officialDailyRequest: { startDate: "", endDate: "" } as IOfficialDiaryPagedRequest, officialDailyResponse: { page: 0, pageSize: 20, items: [] as IOfficialDiaryPagedResponse[] } as PaginationResponse<IOfficialDiaryPagedResponse>, publicationsResponse: { page: 0, pageSize: 20, items: [] as IPublicationPagedResponse[] } as PaginationResponse<IPublicationPagedResponse>, loading: false } as PublicationsState);

    return (
        <PublicationsContext.Provider value={state}>
            <PublicationsContextDispatchContext.Provider value={dispatch}>
                {children}
            </PublicationsContextDispatchContext.Provider>
        </PublicationsContext.Provider>
    );
}

const usePublicationsState = () => {
    const context = useContext(PublicationsContext);
    if (context === undefined) {
        throw new Error('usePublicationsState must be used within a PublicationsProvider');
    }
    return context;
}

const usePublicationsDispatch = () => {
    const context = useContext(PublicationsContextDispatchContext);
    if (context === undefined) {
        throw new Error('useServicesDispatch must be used within a PublicationsProvider');
    }
    return context;
}


export { PublicationsProvider, usePublicationsState, usePublicationsDispatch, ACTION_TYPES };